//描述：错别字校对注入模块专用
//作者：fanglijuan
//时间：2017-2-24
"use strict";
angular.module("heimaCheckImportModule",[
		"heimaCheckServiceModule",
		"markContentHeimaCompareModule",
		"heimacheckInputModule",
	]);